import * as React from "react";

export const VerticalEllipsis: React.SFC = () => {
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="-" fill="none" fillRule="evenodd" opacity="0.5">
        <g
          id="Nic/Header-(Logged-In)"
          transform="translate(-351 -12)"
          fill="#000"
        >
          <path
            d="M353,16 C354.1,16 355,15.1 355,14 C355,12.9 354.1,12 353,12 C351.9,12 351,12.9 351,14 C351,15.1 351.9,16 353,16 L353,16 Z M353,18 C351.9,18 351,18.9 351,20 C351,21.1 351.9,22 353,22 C354.1,22 355,21.1 355,20 C355,18.9 354.1,18 353,18 L353,18 Z M353,24 C351.9,24 351,24.9 351,26 C351,27.1 351.9,28 353,28 C354.1,28 355,27.1 355,26 C355,24.9 354.1,24 353,24 L353,24 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/Nav/verticalEllipsis.tsx